import { lazy, Suspense, useMemo } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import { useSeo } from "@/hooks/use-seo";
import JsonLd from "@/components/JsonLd";
import { organizationSchema, webSiteSchema } from "@/lib/schemas";

const Stats = lazy(() => import("@/components/Stats"));
const HomeSections = lazy(() => import("@/components/HomeSections"));
const InfinitySection = lazy(() => import("@/components/InfinitySection"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  useSeo({
    title: "Sullivan Care | Healthcare Infrastructure Engineered for Scale",
    description: "Sullivan Care builds and manages growth-driven software systems for independent pharmacies and specialty clinics, combining provider portals, operational coordination, and SEO-powered digital platforms.",
    keywords: "healthcare infrastructure, pharmacy growth, provider onboarding, Sullivan Care, compounding pharmacy software, clinic management platform",
    canonical: "/",
  });
  const schemas = useMemo(() => [organizationSchema, webSiteSchema], []);
  return (
    <main className="min-h-screen">
      <JsonLd schema={schemas} />
      <Navbar />
      <Hero />
      <Suspense fallback={<div className="min-h-[200px]" />}>
        <Stats />
        <HomeSections />
        <InfinitySection />
        <Footer />
      </Suspense>
    </main>
  );
};

export default Index;
